module.exports = __webpack_public_path__ + "img/TD.9bd8fff8.svg";